[...document.querySelectorAll(".accordion-panel")].forEach((panel) => {
	const heading = panel.querySelector(".accordion-heading");
	const body = panel.querySelector(".accordion-body");

	console.log(panel, heading, body);
	heading.addEventListener("click", (e) => {
		e.preventDefault();
		const { currentTarget } = e;
		const expanded = currentTarget.getAttribute("aria-expanded") === "true";
		currentTarget.setAttribute("aria-expanded", `${!expanded}`);
		// heading.classList.toggle("border-b");
		heading.querySelector("span").classList.toggle("rotate-[-135deg]");
		heading.querySelector("span").classList.toggle("rotate-45");
		body.classList.toggle("hidden");
	});
});
